<template>
    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_RESERVE_HOME} }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="3"></Process>
        </div>
        <h2 class="font-bold text-2xl pb-2 ">身分認證</h2>
        <div class="pb-8">
            <div class="mb-4 relative">
                <div class="flex justify-center items-center absolute top-0 bottom-0 left-0 right-0 bg-black opacity-50 z-20 text-white rounded-md"
                    v-if="isRecognizing">
                    <div>辨識中</div>
                </div>
                <ImageUploadBox imageText="正面身分證" :imageSrc="frontImageSrc" :changeHandle="changeFrontImage"
                    :clearHandle="clearFrontImage" :imgType="userData.identificationImage.front" />
            </div>
            <ImageUploadBox imageText="背面身分證" :imageSrc="backImageSrc" :changeHandle="changeBackImage"
                :clearHandle="clearBackImage" :imgType="userData.identificationImage.back" />
        </div>
        <div class="mb-8 relative" v-if="idFormVisible">
            <ul class="list">
                <li class="pb-4">
                    <h5 class="font-bold pb-1">身分證(統一編號)</h5>
                    <input type="text" placeholder="請輸入身分證(統一編號)" v-model="userData.identification.identityId" />
                </li>
                <li class="pb-4">
                    <h5 class="font-bold pb-1">發證日期</h5>
                    <DatePicker v-model:visiblePopup="pageData.visiblePopup"
                        v-model:userDate="userData.identification.issuingDate"
                        :minDateGap="110" />
                    <button class="input-base input-calendar" @click="pageData.visiblePopup = true"
                        v-text="formatToTwDate(userData.identification.issuingDate)" />
                </li>
                <li class="pb-4">
                    <h5 class="font-bold pb-1">發證地點</h5>
                    <Multiselect v-model="userData.identification.issuingLocationName" class="select-base"
                        placeholder="請選擇發證地點" track-by="text" label="label" :options="issuingLocations"
                        :can-clear="false" :can-deselect="false" />
                </li>
                <li class="pb-4">
                    <h5 class="font-bold pb-1">領補換類別</h5>
                    <Multiselect v-model="userData.identification.issuingTypeText" class="select-base"
                        placeholder="請選擇領補換類別" track-by="text" label="label" :options="issuingTypes" :can-clear="false"
                        :can-deselect="false" />
                </li>
            </ul>
        </div>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="goNextPageDisable" @click="submit">開始視訊</button>
        </template>
        <Loading :is-loading="pageData.isLoading" />
        <InfoBox v-if="errorBoxVisble" :closeHandel="closeAction" title="系統提示">
            <div v-html="errorMessage" />
        </InfoBox>
    </Layout>
</template>
<script setup>
import '@/assets/cloudCounter/css/style.css';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import ImageUploadBox from '@/components/cloudCounter/ImageUploadBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'

import { postOcr, postValidate } from '@/apis/CloudECounterReserve';
import Loading from '@/components/Loading.vue';
import { ref, computed, reactive, watch } from 'vue';
import Multiselect from '@vueform/multiselect';
import DatePicker from '@/components/dialogs/DatePicker.vue';
import { formatToTwDate } from '@/utils/is/dateUtils';
import routeName from '@/router/constant';

const frontImageSrc = ref('');
const backImageSrc = ref('');
const frontImageSrcFile = ref(null);
const backImageSrcFile = ref(null);
const issuingTypes = ref(['初發', '補發', '換發'])
// 確認是否有API
const issuingLocations = ref(['北縣', '宜縣', '桃縣', '竹縣', '苗縣', '中縣', '彰縣', '投縣', '雲縣', '嘉縣', '南縣', '高縣', '屏縣', '東縣', '花縣', '澎縣', '基市', '竹市', '嘉市', '連江', '金門', '北市', '高市', '新北市', '中市', '南市', '桃市'])
const errorBoxVisble = ref(false);
const errorMessage = ref('');
const upperLimit = ref(false);
const goNextPageDisable = computed(() => (frontImageSrc.value === '' || backImageSrc.value === '' || !idFormVisible.value));
const idFormVisible = ref(false);
const isRecognizing = ref(false);

const userData = reactive({
    identificationImage: {
        back: {
            name: 'back',
            title: '請拍攝身分證反面',
        },
        front: {
            name: 'front',
            title: '請拍攝身分證正面',
        },
    },
    identification: {
        identityId: '',
        issuingLocationName: '',
        issuingTypeText: '',
        issuingDate: '',
    },
});

const pageData = reactive({
    isLoading: false,
    visiblePopup: false,
});

watch([frontImageSrcFile, backImageSrcFile], ([newFront, newBack]) => {
    if (newFront && newBack) {
        pageData.isLoading = true;
        const formData = new FormData();
        formData.append('front', newFront);
        formData.append('back', newBack);
        postOcr(formData).then((res) => {
            idFormVisible.value = true;
            userData.identification.identityId = res.data.identityId;
            // userData.identification.issuingDate = `${Number(res.data.issuingYear) + 1911}/${res.data.issuingMonth}/${res.data.issuingDay}`
            userData.identification.issuingLocationName = res.data.issuingLocationName;
            userData.identification.issuingTypeText = res.data.issuingTypeText;
        }).catch((ex) => {
            if (ex?.data?.errorCode.includes('IdentityRecognition.OCR.Error')) {
                // OCR驗證失敗， 讓使用者自行手動輸入
                idFormVisible.value = true;
            } else {
                errorBoxVisble.value = true;
                errorMessage.value = ex?.data?.errorMessage;
                clearFrontImage();
                clearBackImage();
            }
        }).finally(() => {
            pageData.isLoading = false;
        });
    }
})

const changeFrontImage = (imgData) => {
    // frontImageSrc.value = URL.createObjectURL(e.target.files[0]);
    // frontImageSrcFile.value = e.target.files[0];
    frontImageSrc.value = URL.createObjectURL(imgData);
    frontImageSrcFile.value = imgData;
}

const changeBackImage = (imgData) => {
    backImageSrc.value = URL.createObjectURL(imgData);
    backImageSrcFile.value = imgData;
}

const clearFrontImage = (e) => {
    frontImageSrc.value = '';
    frontImageSrcFile.value = null;
    userData.identification.identityId = '';
    userData.identification.issuingDate = '';
    userData.identification.issuingLocationName = '';
    userData.identification.issuingTypeText = '';
    idFormVisible.value = false;
}

const clearBackImage = (e) => {
    backImageSrc.value = '';
    backImageSrcFile.value = null;
}

const closeAction = () => {
    if(upperLimit.value) {
        window.location = process.env.VUE_APP_FUBON_LIFE_URL;
    } else {
        errorBoxVisble.value = false;
    }
}

const submit = () => {
    if (validateForm()) {
        pageData.isLoading = true;
        const dateArr = formatToTwDate(userData.identification.issuingDate).split('/');
        const request = {
            identityId: userData.identification.identityId,
            issuingYear: dateArr[0],
            issuingMonth: dateArr[1],
            issuingDay: dateArr[2],
            issuingLocationName: userData.identification.issuingLocationName,
            issuingTypeText: userData.identification.issuingTypeText,
        };
        postValidate(request).then(res => {
            if (res?.data?.redirectUrl) {
                window.location = res.data.redirectUrl;
            }
        }).catch(ex => {
            errorMessage.value = ex.data?.errorMessage;
            upperLimit.value = ex.data?.upperLimit;
            errorBoxVisble.value = true;
        }).finally(() => {
            pageData.isLoading = false;
        });
    }
}

const validateForm = () => {
    const fields = ['identityId', 'issuingDate', 'issuingLocationName', 'issuingTypeText'];
    const fieldsText = ['身分證', '發證日期', '發證地點', '領補換類別'];
    errorMessage.value = '';
    for (let [index, field] of fields.entries()) {
        if (!userData.identification[field]) {
            errorBoxVisble.value = true
            errorMessage.value = `請輸入${fieldsText[index]}`
            return false
        }
    }
    return true
}

</script>

<style scoped lang="scss"></style>
